import { render, staticRenderFns } from "./Login.view.vue?vue&type=template&id=00881204&scoped=true"
import script from "./Login.view.vue?vue&type=script&lang=ts"
export * from "./Login.view.vue?vue&type=script&lang=ts"
import style0 from "./Login.view.vue?vue&type=style&index=0&id=00881204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00881204",
  null
  
)

export default component.exports